<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head(stockQuantity)="scope">
        <div style="text-align:center;">
          <div>本次领用前</div>
          <div>库存数量</div>
        </div>
      </template>
      <template v-slot:head(stockRemaining)="scope">
        <div style="text-align:center;">
          <div>本次领用后</div>
          <div>库存余量</div>
        </div>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(stockQuantity)="data">
        {{ Number(data.item.stockQuantity || 0).toFixed(3) }}
      </template>

      <template v-slot:cell(storageLocation)="data">
        {{ data.item.storageLocationLabel }}
      </template>

      <template v-slot:cell(requisitionQuantity)="data">
        {{ Number(data.item.requisitionQuantity || 0).toFixed(3) }}
      </template>

      <template v-slot:cell(unitPrice)="data">
        {{ Number(data.item.unitPrice || 0).toFixed(2) }}
      </template>

      <template v-slot:cell(amountSubtotal)="data">
        {{ Number(data.item.amountSubtotal || 0).toFixed(2) }}
      </template>

      <template v-slot:cell(stockRemaining)="data">
        {{ Number(data.item.stockRemaining || 0).toFixed(3) }}
      </template>

      <template v-slot:cell(dinerType)="data">
        {{ data.item.dinerTypeLabel }}
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ApmsRegCanteenRequisitionDetail",
  data() {
    return {
      tableType: 'detail',
      detailFields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '55px'},
        {key: 'categoryName', label: '类别', width: '120px'},
        {key: 'materialName', label: '物资名称', width: '150px'},
        {key: 'brand', label: '品牌', width: '80px'},
        {key: 'specification', label: '规格', width: '80px'},
        {key: 'unit', label: '单位', width: '80px'},
        {key: 'stockQuantity', label: '库存数量', width: '100px'},
        {key: 'storageLocation', label: '库存地点', width: '100px'},
        {key: 'requisitionQuantity', label: '领用数量', width: '100px'},
        {key: 'unitPrice', label: '单价（元）', width: '100px'},
        {key: 'amountSubtotal', label: '金额小计（元）', width: '110px'},
        {key: 'stockRemaining', label: '库存余量', width: '100px'},
      ],
      dinerFields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '55px'},
        {key: 'dinerType', label: '就餐人员类型', width: '150px'},
        {key: 'laborTeamName', label: '班组', width: '200px'},
        {key: 'dinerCount', label: '就餐人次', width: '130px'},
        {key: 'remarks', label: '备注', width: '150px'},
      ],
      items: [],
    }
  },
  computed: {
    fields1() {
      return this.tableType === 'detail' ? this.detailFields : this.dinerFields
    }
  },
  created() {
    this.tableType = this.$route.query.type || 'detail'
    const data = this.$route.query.data
    if (data) {
      this.items = JSON.parse(data)
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
  }
}
</script>

<style scoped>
</style>
